import { ProductFacet, ProductFacetEntry } from '@/data/types/Product';
import { useMobileApp } from '@/utils/useMobileApp';
import { useMemo } from 'react';

const MOBILE_APP_HIDDEN_ENTRIES: Record<string, string[]> = {
	VISUALIZACION_INTELIGENTE: ['Vista 360°'],
};

export const useVisibleEntries = (facets: ProductFacet[]): Record<string, ProductFacetEntry[]> => {
	const { isMobileApp } = useMobileApp();
	return useMemo(() => {
		const result: Record<string, ProductFacetEntry[]> = {};
		facets.forEach((facetItem) => {
			const propertyValue = facetItem.extendedData?.propertyvalue;
			const hiddenLabels = isMobileApp ? MOBILE_APP_HIDDEN_ENTRIES[propertyValue] : undefined;
			result[facetItem.value] = hiddenLabels?.length
				? facetItem.entry?.filter((entry) => !hiddenLabels.includes(entry.label))
				: facetItem.entry;
		});
		return result;
	}, [facets, isMobileApp]);
};
